import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { Controller } from "@commoncore/controller/Controller";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { AddHashTagImplementation } from "../implementation/AddHashTagImplementation";

export class AddHashTagController extends Controller{
    public universalService:any;
    public static singleInstance = null;
    fileOperationsImplementation:any;
    addHashTagImplementation:any;

    public constructor(public globalService:GlobalService) {
        super(globalService);
        this.addHashTagImplementation = AddHashTagImplementation.getInstance(this.globalService);
        this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
        this.fileOperationsImplementation.setHandler(this.globalService)
        this.setEnvObjects(globalService);
      }
    
      public static getInstance(globalService): AddHashTagController {
        if (this.singleInstance == null) {
          this.singleInstance = new AddHashTagController(globalService);
          return this.singleInstance;
        } else {
          return this.singleInstance;
        }
      }
    
    
      setEnvObjects(globalService){
        this.universalService = globalService.getUniversalServiceRef();
        this.addHashTagImplementation.setHandler(this.globalService);
      }

      async updateHashTags(newAdded,removedTags){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["updateTags"];
        this.addHashTagImplementation.setHandler(this.globalService);
        try{
          if($('.inpt-tags').focus() && this.addHashTagImplementation.currentTagName != ""){
            return "emptyTags"
          }        
          let totalcount = this.addHashTagImplementation.newTagsList.length+this.addHashTagImplementation.existingTagsList.length
          var payload = this.addHashTagImplementation.setPayloadForUpdatingTags(newAdded,removedTags)
          var result = await this.addHashTagImplementation.updateHashTags(url,payload,newAdded,this.addHashTagImplementation.recentsTagsList,totalcount);
          return result
        }catch(err){
          console.log("error in adding hashtag",err);
        }
      }

      saveUpdatedTagsList(){
        
      }

      async getRecentTags(){
        var url  =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]  + ENV_CONFIG.commonUrls["recetTags"];
        this.addHashTagImplementation.setHandler(this.globalService);
        try {
          return await this.addHashTagImplementation.getRecentTags(url);
        }catch(exception){
          console.log("expception in fetching recent tag list",exception);
        } finally{
          this.universalService.showLoader = false;   
        }
      }

      async getHashTagsForTheObject(){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["updateTags"] + "/" + this.addHashTagImplementation.selectedObject["objectKey"];
        this.addHashTagImplementation.setHandler(this.globalService);
        try{
          var result = await this.addHashTagImplementation.getHashTagsForTheObject(url);
          return result
        }catch(err){
          console.log("error in fetching hashtag",err);
        } 
      }

}